<template>
  <div class="car-message">
    <div v-if="sender" class="car-message-container car-sender">
      <div class="car-talk-bubble">
        <div class="car-talk-text">
          {{message.message}}
        </div>
      </div>
      <div class="car-talk-bubble-arrow"></div>
      <user-logo></user-logo>
    </div>
    <div v-else class="car-message-container car-receiver">
      <div><user-logo></user-logo></div>
      <div class="car-talk-bubble-arrow"></div>
      <div class="car-talk-bubble">
        <div class="car-talk-text">
          {{message.message}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserLogo from './UserLogo';

export default {
  name: 'Message',
  props: {
    sender: {
      type: Boolean,
      default: false
    },
    message: {
    },
    fullname: {

    }
  },
  components: {
    UserLogo
  }
};
</script>
